export default __webpack_public_path__ + "static/media/download.1f8e063c.svg";